import { all } from 'redux-saga/effects'
import user from './user/sagas'
import noticias from './noticias/sagas'
import tecnicos from './tecnicos/sagas'
import reforcoSinal from './reforcoSinal/sagas'

export default function* rootSaga(): any {
  return yield all([user, noticias, tecnicos, reforcoSinal])
}
